import { render, staticRenderFns } from "./Expense.vue?vue&type=template&id=c1ba3d90&scoped=true&"
import script from "./Expense.vue?vue&type=script&lang=js&"
export * from "./Expense.vue?vue&type=script&lang=js&"
import style0 from "./Expense.vue?vue&type=style&index=0&id=c1ba3d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ba3d90",
  null
  
)

export default component.exports